export const CLEANUP_HUB_STATE = 'cleanup-hub-state';
const cleanupHubState = () => ({ type: CLEANUP_HUB_STATE });
export default cleanupHubState;
